import React, {useContext, useEffect, useState} from 'react';
import {Button, Form, message, Modal, Radio, Select} from 'antd';
import DeleteComponent from '../common/DeleteComponent';
import EditComponent from '../common/EditComponent';
import Search from 'antd/es/input/Search';
import {sideMenuContext} from '../../../router/IndexRouter';
import {Arguments} from '../common/Arguments';
import {GetApiMethod, RealtimeGetMethod} from '../common/ApiMethod';
import TableComponent from '../common/TablePaginationComponent';
import {HanToNumber} from '../common/ConversionMethod';
import SearchBox from '../common/SearchBoxComponent';
import {SortByOrganizationPost} from '../common/SortListByPost';

const MeetingDelegate = (props) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const {currentItem, setCurrentItem, dataSource, setDataSource, setCopyDataSource} = useContext(sideMenuContext);
	const currentUrl = window.location.href;
	const getApi = Arguments.host + '/society_organization/society/api!meetingDelegate.do';

	useEffect(() => {
		setDataSource([]);
		GetApiMethod({getApi, setDataSource, setCopyDataSource});
	}, [getApi]);

	const columns = [
		{
			title: '序号',
			dataIndex: 'showIndex',
			width: 100,
			sorter: (a, b) => a.showIndex - b.showIndex,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '届次',
			dataIndex: 'meetingTermName',
			width: 80,
		},
		{
			title: '姓名',
			dataIndex: 'memberName',
			width: 80,
			sorter: (a, b) => a.memberName.localeCompare(b.memberName),
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '性别',
			dataIndex: 'memberSex',
			width: 60,
		},
		{
			title: '出生日期',
			dataIndex: 'memberBorn',
			width: 110,
		},
		{
			title: '民族',
			responsive: ['lg'],
			dataIndex: 'memberMz',
			width: 60,
		},
		{
			title: '政治面貌',
			dataIndex: 'memberZzmm',
			width: 100,
		},
		{
			title: '文化程度',
			dataIndex: 'memberEducational',
			width: 100,
		},
		{
			title: '社团职务',
			dataIndex: 'organizationPost',
			width: 100,
		},
		{
			title: '工作单位（或原）',
			responsive: ['lg'],
			dataIndex: 'memberUnit',
			width: 160,
		},
		{
			title: '职务',
			responsive: ['lg'],
			dataIndex: 'memberPost',
			width: 130,
		},
		{
			title: '职称',
			responsive: ['lg'],
			dataIndex: 'memberProfessional',
		},
		{
			title: '大会职务',
			responsive: ['lg'],
			dataIndex: 'meetingMemberPost',
			width: 100,
		},
		{
			title: '手机号',
			dataIndex: 'memberMobilePhone',
			width: 120,
		},
		{
			title: '操作',
			width: 140,
			render: (item) => (
				<>
					<EditComponent item={item} url={currentUrl}/>
					<DeleteComponent
						item={item}
						postApi={[Arguments.host + '/society_organization/society/api!addMeetingDelegate.do']}
						getApi={getApi}
					/>
				</>
			),
		},
	];

	// 模态框组件
	const [searchResult, setSearchResult] = useState([]);
	const [username, setUsername] = useState([]);
	const [allData, setAllData] = useState([]);

	const showModal = () => {
		setIsModalOpen(true);
		const orgId = (parseInt(sessionStorage.getItem('coffee')) / 20).toString();
		const role = sessionStorage.getItem('rain');
		// 从后端接口中请求搜索用户的结果，将完整信息存入 searchResult 中；将提取出来的用户名存入 username 中
		const stApi = Arguments.host + '/society_organization/society/api!memberPersonal.do';
		const mfApi = Arguments.host + '/society_organization/society/api!researcherInformation.do';
		RealtimeGetMethod(role.includes('社会') || role.includes('社团') ? stApi : mfApi).then(resultList => {
			const filterData = resultList && resultList.length > 0 ? resultList.filter(item =>
				item.organizationId === orgId,
			) : [];
			setAllData(filterData);
			setSearchResult(filterData);
			setUsername(filterData.map(user => user.memberName || user.peopleName));
		});
	};
	const handleOk = () => {
		// 将下拉框中选中的 "第七届" 等内容转成 id，并放入 sessionStorage 中
		const section = form.getFieldValue('section');
		const meetingTermId = HanToNumber(section).toString();
		// 如果没有搜索到用户或者没有选择用户，提示错误信息
		if (username.length === 0 || currentItem.length === 0) {
			message.warning('没有可新增的成员');
		} else {
			setIsModalOpen(false);
			// 跳转到新增的表单页面，将当前选中的用户信息加上选择的届次，带入新增页面的表单中 setCurrentItem
			setCurrentItem({...currentItem, meetingTermName: section, meetingTermId: meetingTermId});
			props.history.push('/society/meeting-delegate/add');
		}
	};
	const handleCancel = () => {
		form.setFieldsValue({name: ''});
		setIsModalOpen(false);
		setUsername(allData.map(user => user.memberName || user.peopleName));
	};

	const onSearch = (userName) => {
		const filterData = allData?.filter(user =>
			user.memberName?.includes(userName) || user.peopleName?.includes(userName),
		);
		setSearchResult(filterData);
		setUsername(filterData.map(user => user.memberName || user.peopleName));
	};

	const onChange = (e) => {
		// 将当前选中的用户信息保存到 currentItem 中
		setCurrentItem(searchResult[e.target.value]);
	};

	// 将需要展示的用户列表转成字典形式，用于确定所选的是第几个用户
	const nameList = username.map((user, index) => ({label: user, value: index}));

	const [form] = Form.useForm();

	const indexDataSource = SortByOrganizationPost(dataSource).map((data, index) => ({showIndex: index + 1, ...data}));

	return (
		<>
			<Button type="primary" onClick={() => showModal()}
					style={{marginBottom: 10}}>新增</Button>
			<Modal title="请选择代表大会成员" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}
				   okText="确定新增">
				<Form form={form}>
					<Form.Item name="section" label="请选择届次" rules={[{required: true, message: '内容不能为空'}]}
							   initialValue="第七届">
						<Select style={{width: 300}}>
							<Select.Option value="第五届">第五届</Select.Option>
							<Select.Option value="第六届">第六届</Select.Option>
							<Select.Option value="第七届">第七届</Select.Option>
							<Select.Option value="第八届">第八届</Select.Option>
							<Select.Option value="第九届">第九届</Select.Option>
							<Select.Option value="第十届">第十届</Select.Option>
							<Select.Option value="第十一届">第十一届</Select.Option>
						</Select>
					</Form.Item>

					<Form.Item name="name" label="请输入姓名" style={{marginLeft: 11}}>
						<Search style={{width: 300}} onSearch={onSearch} enterButton/>
					</Form.Item>

					<Radio.Group style={{marginLeft: 13}} onChange={onChange} options={nameList} name="selectName"/>
				</Form>
			</Modal>
			<SearchBox/>
			<TableComponent dataSource={indexDataSource} columns={columns}/>
		</>
	);
};

export default MeetingDelegate;

